var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-footer"},[_c('div',{staticClass:"links"},[_vm._t("default"),_c('div',[_vm._v("Copyright "),_c('icon',{attrs:{"name":"copyright","size":14}}),_vm._v(_vm._s(_vm.copyright))],1)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }